export const USDT = 'USDT';
